
// import { useState, useEffect, useRef } from "react";
// import { ArrowLeft, Loader2, AlertCircle } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import Chart from "chart.js/auto";
// import annotationPlugin from "chartjs-plugin-annotation";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { getSWCapabilityData } from "../../../services/apiService";
// import Swal from "sweetalert2";

// Chart.register(annotationPlugin, ChartDataLabels);

// const toPercent = (v) => (v == null ? null : Math.round(v * 100));

// const LoadingState = () => (
//   <div className="min-h-screen bg-[#0f1b2b] flex flex-col items-center justify-center gap-3">
//     <Loader2 className="w-10 h-10 text-blue-400 animate-spin" />
//     <p className="text-gray-400 text-sm">Loading capability data…</p>
//   </div>
// );

// const ErrorState = ({ message, onRetry }) => (
//   <div className="min-h-screen bg-[#0f1b2b] flex flex-col items-center justify-center gap-4">
//     <AlertCircle className="w-10 h-10 text-red-400" />
//     <p className="text-red-300 text-sm">{message}</p>
//     <button
//       onClick={onRetry}
//       className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg transition"
//     >
//       Retry
//     </button>
//   </div>
// );

// const SummaryChart = ({ summaryChart, onVendorClick, onBack }) => {
//   const chartRef = useRef(null);
//   const canvasRef = useRef(null);
//   const navigate = useNavigate();

//   const {
//     categories = [],
//     values = [],
//     baseLine = {},
//     analysisText = "",
//   } = summaryChart || {};

//   const parseAnalysisText = (text) => {
//     if (!text || typeof text !== "string") {
//       return {
//         summary: "",
//         conclusions: [],
//       };
//     }

//     // Normalize line breaks and spaces
//     let normalizedText = text
//       .replace(/\r\n/g, "\n")
//       .replace(/\r/g, "\n")
//       .trim();
//     normalizedText = normalizedText.replace(
//       /\s+(?=\d+\s*[）)])/g,
//       "\n"
//     );

//     let summary = "";
//     const conclusions = [];
//     const summaryMatch = normalizedText.match(
//       /Summary\s*[:：]\s*([\s\S]*?)(?=\n\s*(?:由上述图表可知|1\s*[）)]|$))/i
//     );

//     if (summaryMatch) {
//       summary = summaryMatch[1]
//         .replace(/\s+/g, " ")
//         .trim();
//     }

//     /*
//      * ------------------------------------------------------------
//      * Extract numbered conclusions
//      * ------------------------------------------------------------
//      *
//      * Supports:
//      *
//      * 1）xxxx
//      * 2）xxxx
//      *
//      * and
//      *
//      * 1) xxxx
//      * 2) xxxx
//      */
//     const conclusionRegex =
//       /(?:^|\n)\s*(\d+)\s*[）)]\s*([\s\S]*?)(?=\n\s*\d+\s*[）)]|$)/g;

//     let match;

//     while ((match = conclusionRegex.exec(normalizedText)) !== null) {
//       const number = match[1];

//       const conclusionText = match[2]
//         .replace(/\s+/g, " ")
//         .trim();

//       if (conclusionText) {
//         conclusions.push({
//           number,
//           text: conclusionText,
//         });
//       }
//     }

//     /*
//      * ------------------------------------------------------------
//      * Fallback
//      * ------------------------------------------------------------
//      *
//      * If Summary wasn't found using the exact "Summary:" format,
//      * try to locate it manually.
//      */
//     if (!summary) {
//       const summaryIndex = normalizedText.search(
//         /Summary\s*[:：]/i
//       );

//       if (summaryIndex !== -1) {
//         const summaryStart = normalizedText
//           .slice(summaryIndex)
//           .replace(/^Summary\s*[:：]\s*/i, "");

//         const firstConclusionIndex = summaryStart.search(
//           /(?:\n|^)\s*\d+\s*[）)]/
//         );

//         if (firstConclusionIndex !== -1) {
//           summary = summaryStart
//             .slice(0, firstConclusionIndex)
//             .replace(/\s+/g, " ")
//             .trim();
//         } else {
//           summary = summaryStart
//             .replace(/\s+/g, " ")
//             .trim();
//         }
//       }
//     }

//     return {
//       summary,
//       conclusions,
//     };
//   };

//   /*
//    * Parse the dynamic Excel analysis text.
//    *
//    * Since analysisText comes from summaryChart, whenever the
//    * uploaded Excel changes and summaryChart changes, this
//    * automatically gets recalculated.
//    */
//   const {
//     summary: dynamicSummary,
//     conclusions: dynamicConclusions,
//   } = parseAnalysisText(analysisText);

//   /*
//    * ============================================================
//    * BASELINE
//    * ============================================================
//    */

//   /*
//    * Get the baseline value for each vendor.
//    *
//    * Example:
//    *
//    * baseLine = {
//    *   "TPV（FQ）": 0.9,
//    *   "Ostar": 0.8,
//    *   "LnT": 0.8,
//    *   "Deweco": 0.8,
//    *   "Hannovo": 0.2,
//    *   "KTC": 0.1,
//    *   "Hengfakj": 0.8,
//    *   "CTX": 0.8,
//    *   "MTC": 0.9
//    * }
//    *
//    * This becomes:
//    *
//    * [90, 80, 80, 80, 20, 10, 80, 80, 90]
//    */

//   const getBaselineValue = (vendor) => {
//     if (!vendor || !baseLine) {
//       return null;
//     }

//     /*
//      * First try exact vendor name.
//      */
//     if (
//       Object.prototype.hasOwnProperty.call(
//         baseLine,
//         vendor
//       )
//     ) {
//       const value = baseLine[vendor];

//       return typeof value === "number"
//         ? value
//         : null;
//     }

//     /*
//      * Fallback matching.
//      *
//      * This handles cases such as:
//      *
//      * TPV（FQ）
//      * TPV (FQ)
//      * TPV(FQ)
//      *
//      * without changing the actual displayed vendor name.
//      */
//     const normalizeVendorName = (name) =>
//       String(name)
//         .replace(/[（）]/g, "")
//         .replace(/[()]/g, "")
//         .replace(/\s+/g, "")
//         .toUpperCase();

//     const normalizedVendor =
//       normalizeVendorName(vendor);

//     const matchingKey = Object.keys(baseLine).find(
//       (key) =>
//         normalizeVendorName(key) ===
//         normalizedVendor
//     );

//     if (!matchingKey) {
//       return null;
//     }

//     const value = baseLine[matchingKey];

//     return typeof value === "number"
//       ? value
//       : null;
//   };

//   /*
//    * Create one baseline value for every category.
//    *
//    * Backend values are fractions:
//    * 0.9 = 90%
//    * 0.8 = 80%
//    * 0.2 = 20%
//    * 0.1 = 10%
//    */
//   const baselineValues = categories.map((vendor) => {
//     const value = getBaselineValue(vendor);

//     return value != null
//         ? Math.round(value * 100)
//         : null;
// });

//   const chartData = {
//     labels: categories,
//     datasets: [
//       {
//         type: "bar",
//         label: "SW Capability",
//         data: values.map(toPercent),
//         backgroundColor: categories.map((v) =>
//           v?.toUpperCase().includes("TPV")
//             ? "#9ca3af"
//             : "#3b82f6"
//         ),
//         borderRadius: 0,
//         maxBarThickness: 56,
//         datalabels: {
//           anchor: "end",
//           align: "top",
//           offset: 4,
//           color: "white",
//           font: () => {
//             const width = window.innerWidth;

//             let size = 15;
//             if (width < 640) {
//               size = 10;
//             } else if (width < 1024) {
//               size = 12;
//             }

//             return {
//               size,
//               weight: 600,
//             };
//           },
//           formatter: (v) =>
//             v != null
//               ? `${v}%`
//               : "",
//         },
//         order: 2,
//       },

//       // ==========================================
//       // Dynamic baseline
//       // ==========================================
//       {
//         type: "line",
//         label: "Base Line",
//         data: baselineValues,
//         borderColor: "#ef4444",
//         backgroundColor: "#ef4444",
//         borderWidth: 3,
//         pointRadius: 0,
//         pointHoverRadius: 5,
//         pointBackgroundColor: "#ef4444",
//         pointBorderColor: "#ef4444",
//         tension: 0,
//         spanGaps: false,
//         fill: false,
//         order: 1,
//         datalabels: {
//           display: false,
//         },
//       },
//     ],
//   };
//   /*
//    * ============================================================
//    * CHART
//    * ============================================================
//    */

//   useEffect(() => {
//     if (!canvasRef.current) {
//       return;
//     }

//     const ctx = canvasRef.current.getContext("2d");

//     const getAxisFontSize = () => {
//       const width = window.innerWidth;

//       if (width < 640) {
//         return 10;
//       }
//       if (width < 1024) {
//         return 12;
//       }
//       return 15;
//     };

//     const chart = new Chart(ctx, {
//       type: "bar",
//       data: chartData,
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         onClick: (event, elements) => {
//           if (elements.length === 0) {
//             return;
//           }

//           const element = elements[0];

//           /*
//            * Only respond to clicks on the BAR dataset.
//            *
//            * Clicking the red baseline should not
//            * open the vendor detail page.
//            */
//           const datasetIndex =
//             element.datasetIndex;

//           const clickedDataset =
//             chartData.datasets[datasetIndex];

//           if (clickedDataset?.type !== "bar") {
//             return;
//           }
//           const idx = element.index;
//           const vendor = categories[idx];
//           if (
//             !vendor
//               ?.toUpperCase()
//               .includes("TPV")
//           ) {
//             onVendorClick({ vendor });
//           }
//         },
//         plugins: {
//           legend: {
//             display: false,
//           },
//           tooltip: {
//             backgroundColor: "black",
//             titleColor: "white",
//             bodyColor: "white",
//             borderColor: "black",
//             borderWidth: 1,
//             callbacks: {
//               title: (items) => items[0].label,
//               label: (item) => {
//                 const val = item.raw;
//                 return val != null
//                   ? `${item.dataset.label}: ${val}%`
//                   : `${item.dataset.label}: N/A`;
//               },
//             },
//           },

//           /*
//            * We don't use annotation for the
//            * summary baseline anymore.
//            *
//            * The baseline is the line dataset above.
//            */

//           datalabels: {
//             display: (context) => context.dataset.type === "bar",
//           },
//         },
//         scales: {
//           x: {
//             grid: {
//               display: false,
//             },
//             ticks: {
//               color: "white",
//               font: () => ({
//                 size: getAxisFontSize(),
//               }),
//             },
//           },
//           y: {
//             min: 0,
//             max: 120,
//             ticks: {
//               stepSize: 20,
//               callback: (v) =>
//                 `${v}%`,
//               color: "white",
//               padding: 10,
//               font: () => ({
//                 size: getAxisFontSize(),
//               }),
//             },
//             grid: {
//               color: "white",
//               borderDash: [3, 3],
//             },
//           },
//         },
//       },
//     });

//     chartRef.current = chart;

//     return () => {
//       chart?.destroy();
//       chartRef.current = null;
//     };
//   }, [
//     categories,
//     values,
//     baseLine,
//     onVendorClick,
//   ]);

//   /*
//    * ============================================================
//    * RESPONSIVE CHART HEIGHT
//    * ============================================================
//    */

//   const getResponsiveChartHeight = () => {
//     const width = window.innerWidth;

//     if (width < 640) {
//       return 320;
//     }
//     if (width < 1024) {
//       return 380;
//     }
//     return 450;
//   };

//   /*
//    * ============================================================
//    * UI
//    * ============================================================
//    */

//   return (
//     <div className="min-h-screen bg-black text-white">
//       <div className="w-full px-4 sm:px-6 lg:px-8 pt-3 pb-10">

//         {/* Header */}
//         <div className="flex items-center gap-3 mb-1">
//           <button
//             onClick={() =>
//               navigate("/vendor-capability",{ state: { view: "software",},})
//             }
//             className="p-1 hover:bg-[#1b2a3c] transition"
//           >
//             <ArrowLeft className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
//           </button>

//           <h1 className="text-base sm:text-2xl font-bold tracking-tight">
//             TV Software Capability
//           </h1>
//         </div>

//         {/* =====================================================
//             Chart Card
//         ====================================================== */}

//         <div className="bg-black p-4 sm:p-6 shadow-lg border-t border-[#243448]">
//           <h2 className="text-center text-sm sm:text-xl font-semibold text-white sm:mb-6 mb-2 sm:mt-5">
//             ODMs SW Validation Capability
//           </h2>

//           <div className="flex justify-center sm:p-0 p-5 sm:-ml-0 -ml-5">
//             <div className="w-[120%] sm:w-full max-w-[1500px]"
//               style={{
//                 height: `${getResponsiveChartHeight()}px`,
//               }}
//             >
//               <canvas ref={canvasRef} />
//             </div>
//           </div>
//         </div>

//         {/* =====================================================
//             Analysis and Conclusions
//         ====================================================== */}

//         <div className="mt-1 sm:mb-1 mb-3 sm:ml-10 sm:mt-15">
//           <h3 className="text-lg sm:text-2xl font-semibold">
//             Analysis and Conclusions：
//           </h3>
//         </div>

//         {/* =====================================================
//             Dynamic Summary
//         ====================================================== */}

//         <div className="text-white text-sm sm:text-base leading-relaxed mb-1 sm:ml-10 sm:mt-8">
//           {dynamicSummary && (<p className="mb-3 text-sm sm:text-base">
//               <span className="font-semibold text-sm sm:text-base">
//                 Summary：
//               </span>{" "}

//               {dynamicSummary}

//             </p>
//           )}

//           {dynamicConclusions.length > 0 && (
//             <p className="mb-2">
//               由上述图表可知：
//             </p>
//           )}

//         </div>

//         {/* =====================================================
//             Dynamic Conclusions
//         ====================================================== */}

//         {dynamicConclusions.length > 0 && (

//           <ol className="list-decimal pl-6 text-sm sm:text-base leading-relaxed sm:ml-10">

//             {dynamicConclusions.map(
//               (item, index) => (

//                 <li
//                   key={`${item.number}-${index}`}
//                   className="mb-2"
//                 >
//                   {item.text}
//                 </li>

//               )
//             )}
//           </ol>
//         )}

//         {/* =====================================================
//             No Analysis Data
//         ====================================================== */}

//         {!dynamicSummary &&
//           dynamicConclusions.length === 0 && (
//             <div className="text-gray-400 text-sm sm:text-base sm:ml-10 mt-4">
//               No analysis and conclusion data available.
//             </div>
//           )}
//       </div>
//     </div>
//   );
// };

// const VendorDetailChart = ({ vendorName, vendorChart, onBack }) => {
//   const chartRef = useRef(null);
//   const canvasRef = useRef(null);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   const {
//     title = `${vendorName} Function proportion`,
//     functionCategories = [],
//     values = [],
//     baseLines = [],
//     analysisText = "",
//   } = vendorChart || {};

//   const lineColors = ["#f97316", "#eab308", "#22d3ee", "#a78bfa"];

//   const getResponsiveFont = (desktop = 15, tablet = 13, mobile = 11) => {
//     const width = window.innerWidth;

//     if (width < 640) return mobile;
//     if (width < 1024) return tablet;
//     return desktop;
//   };


//   const getResponsiveFontSize = (desktop = 10, tablet = 9, mobile = 8) => {
//     const width = window.innerWidth;

//     if (width < 640) return mobile;
//     if (width < 1024) return tablet;
//     return desktop;
//   };
//   const chartData = {
//     labels: functionCategories,
//     datasets: [
//       ...baseLines.map((bl, i) => ({
//         type: "line",
//         label: bl.label,
//         data: functionCategories.map((fn) => toPercent(bl.values?.[fn] ?? null)),
//         borderColor: lineColors[i % lineColors.length],
//         backgroundColor: lineColors[i % lineColors.length],
//         borderWidth: 3,
//         pointRadius: 4,
//         pointHoverRadius: 6,
//         tension: 0,
//         spanGaps: true,
//         order: 1,
//       })),
//       {
//         type: "bar",
//         label: vendorName,
//         data: values.map(toPercent),
//         backgroundColor: "#3b82f6",
//         borderRadius: 4,
//         maxBarThickness: 56,
//         datalabels: {
//           anchor: "end",
//           align: "top",
//           offset: 4,
//           color: "#e2e8f0",
//           font: () => ({
//             size: getResponsiveFont(15, 13, 11),
//             weight: 600
//           }),
//           formatter: (v) => (v != null ? `${v}%` : ""),
//         },
//         order: 2,
//       },
//     ],
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setScreenWidth(window.innerWidth);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     if (!canvasRef.current) return;
//     const allValues = [
//       ...values.map(toPercent),
//       ...baseLines.flatMap((bl) =>
//         functionCategories.map((fn) => toPercent(bl.values?.[fn] ?? 0))
//       ),
//     ];

//     const validValues = allValues.filter((v) => v != null && !isNaN(v));
//     const maxValue = validValues.length ? Math.max(...validValues) : 0;

//     const getStepSize = (max) => {
//       if (max <= 90) return 10;
//       if (max <= 180) return 20;
//       if (max <= 250) return 50;
//       if (max <= 500) return 100;
//       return 200;
//     };

//     const stepSize = getStepSize(maxValue);
//     const roundedMax = Math.ceil(maxValue / stepSize) * stepSize;
//     const yAxisMax = roundedMax + stepSize;
//     const ctx = canvasRef.current.getContext("2d");
//     const chart = new Chart(ctx, {
//       data: chartData,
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {

//           legend: {
//             position: "bottom",
//             labels: {
//               color: "#94a3b8",
//               font: () => ({
//                 size: getResponsiveFont(15, 13, 11)
//               }),
//               padding: 16,
//               boxWidth: 100,

//               sort: (a, b) => {
//                 const getPriority = (label) => {
//                   if (label === vendorName) return 0;
//                   if (label.toLowerCase().includes("base")) return 1;
//                   return 2;
//                 };

//                 return getPriority(a.text) - getPriority(b.text);
//               }
//             }
//           },
//           tooltip: {
//             mode: "index",
//             intersect: false,
//             backgroundColor: "#0f1b2b",
//             titleColor: "#d1d5db",
//             bodyColor: "#d1d5db",
//             borderColor: "#2a3f55",
//             borderWidth: 1,
//             callbacks: {
//               label: (item) => {
//                 const val = item.raw;
//                 return `${item.dataset.label}: ${val != null ? val + "%" : "N/A"
//                   }`;
//               },
//             },
//           },
//           datalabels: {
//             display: (context) => context.dataset.type === "bar",
//           },
//         },

//         scales: {
//           x: {
//             ticks: {
//               color: "#94a3b8",
//               font: () => ({
//                 size: getResponsiveFont(15, 13, 11)
//               })
//             },
//             grid: { display: false },
//           },

//           y: {
//             min: 0,
//             max: yAxisMax,
//             ticks: {
//               stepSize: stepSize,
//               callback: (v) => `${Number(v).toFixed(2)}%`,
//               color: "#94a3b8",
//               font: () => ({
//                 size: getResponsiveFont(15, 13, 11)
//               }),
//             },
//             grid: {
//               color: "white",
//               borderDash: [3, 3],
//             },
//           }
//         },
//       },
//     });

//     chartRef.current = chart;

//     return () => chart?.destroy();
//   }, [functionCategories, values, baseLines, vendorName, lineColors, screenWidth]);
//   const getResponsiveChartHeight = () => {
//     const width = window.innerWidth;

//     if (width < 640) return 390;
//     if (width < 1024) return 380;
//     return 450;
//   };

//   return (
//     <div className="min-h-screen bg-black text-white">
//       <div className="w-full px-4 sm:px-6 pt-6 pb-10">
//         <div className="flex items-center gap-3 mb-1">
//           <button
//             onClick={onBack}
//             className="p-1 hover:bg-[#1b2a3c] transition"
//           >
//             <ArrowLeft className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
//           </button>

//           <h1 className="text-base sm:text-2xl font-bold tracking-tight">
//             TV Software Capability
//           </h1>
//         </div>

//         <div className="bg-black p-4 sm:p-6 mb-5 sm:mt-0 -mt-6 text-center shadow-lg border-t border-[#243448]">
//           <h2 className="text-center text-sm sm:text-xl font-semibold text-white mb-5">
//             {title}
//           </h2>
//           <div className="flex justify-center">
//             <div
//               style={{
//                 height: getResponsiveChartHeight(),
//                 width: "100%",
//                 maxWidth: 1500
//               }}
//             >
//               <canvas ref={canvasRef} />
//             </div>
//           </div>
//         </div>
//         <div className="w-full flex justify-center -mt-5  sm:mb-5">
//           <div className="bg-black  p-4 sm:p-1 border border-black w-full max-w-[1500px]">
//             <p className="text-xs sm:text-lg font-bold mb-1 text-white">
//               Remark：
//             </p>

//             <p className="text-xs sm:text-lg text-white leading-relaxed">
//               The percentage of each function on the chart is the number of test
//               cases for the corresponding function module of the ODM / the number
//               of test cases for the corresponding function module of the TPV.
//             </p>
//           </div>
//         </div>

//         {analysisText && (
//           <div className="bg-black rounded-2xl sm:p-10  border border-black  ">
//             <h3 className="text-sm sm:text-2xl font-semibold mb-2">
//               Analysis and Conclusions：
//             </h3>
//             <p className="text-xs sm:text-sm text-white leading-relaxed whitespace-pre-line">
//               {analysisText}
//             </p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default function TVSoftwareCapability() {
//   const navigate = useNavigate();

//   const [view, setView] = useState("summary");
//   const [selectedVendor, setSelectedVendor] = useState(null);
//   const [apiData, setApiData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   const fetchData = async () => {
//   try {
//     setLoading(true);
//     setError(null);
//     const result = await getSWCapabilityData({
//       category: "Vendor Capability",
//       sub_category: "software",
//       productType: "TV",
//     });

//     // No active template
//     if (
//       result?.success === false &&
//       result?.error === "Template not found"
//     ) {
//       await Swal.fire({
//         icon: "warning",
//         title: "Template Missing",
//         text: "File needs to be uploaded in Template Management",
//         confirmButtonText: "OK",
//         confirmButtonColor: "#2563eb",
//         background: "white",
//         color: "black"
//       });

//       // Go back to Vendor Capability after OK
//       navigate("/vendor-capability", {
//         state: { view: "software" }
//       });

//       return;
//     }

//     // Only set data when an actual template exists
//     setApiData(result?.data ?? result);

//   } catch (err) {
//     console.error("API Error:", err);

//     setError(
//       err?.message ?? "Failed to load data"
//     );

//   } finally {
//     setLoading(false);
//   }
// };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   if (loading) return <LoadingState />;
//   if (error) return <ErrorState message={error} onRetry={fetchData} />;
//   if (!apiData) return <ErrorState message="No data returned from server." onRetry={fetchData} />;

//   if (view === "vendor-detail" && selectedVendor) {
//     return (
//       <VendorDetailChart
//         vendorName={selectedVendor}
//         vendorChart={apiData.vendorCharts?.[selectedVendor] ?? {}}
//         onBack={() => {
//           setSelectedVendor(null);
//           setView("summary");
//         }}
//       />
//     );
//   }

//   return (
//     <SummaryChart
//       summaryChart={apiData.summaryChart ?? {}}
//       onVendorClick={(entry) => {
//         setSelectedVendor(entry.vendor);
//         setView("vendor-detail");
//       }}
//       onBack={() => navigate(-1)}
//     />
//   );
// }

import { useState, useEffect, useRef } from "react";
import { ArrowLeft, Loader2, AlertCircle } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import Chart from "chart.js/auto";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getSWCapabilityData } from "../../../services/apiService";
import Swal from "sweetalert2";

Chart.register(annotationPlugin, ChartDataLabels);

const toPercent = (v) => (v == null ? null : Math.round(v * 100));

const LoadingState = () => (
  <div className="min-h-screen bg-[#0f1b2b] flex flex-col items-center justify-center gap-3">
    <Loader2 className="w-10 h-10 text-blue-400 animate-spin" />
    <p className="text-gray-400 text-sm">Loading capability data…</p>
  </div>
);

const ErrorState = ({ message, onRetry }) => (
  <div className="min-h-screen bg-[#0f1b2b] flex flex-col items-center justify-center gap-4">
    <AlertCircle className="w-10 h-10 text-red-400" />
    <p className="text-red-300 text-sm">{message}</p>

    <button
      onClick={onRetry}
      className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-lg transition"
    >
      Retry
    </button>
  </div>
);

const SummaryChart = ({
  summaryChart,
  onVendorClick,
  onBack,
  productType,
}) => {
  const chartRef = useRef(null);
  const canvasRef = useRef(null);
  const navigate = useNavigate();

  const {
    categories = [],
    values = [],
    baseLine = {},
    analysisText = "",
  } = summaryChart || {};

  const parseAnalysisText = (text) => {
    if (!text || typeof text !== "string") {
      return {
        summary: "",
        conclusions: [],
      };
    }

    // Normalize line breaks and spaces
    let normalizedText = text
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .trim();

    normalizedText = normalizedText.replace(
      /\s+(?=\d+\s*[）)])/g,
      "\n"
    );

    let summary = "";
    const conclusions = [];

    const summaryMatch = normalizedText.match(
      /Summary\s*[:：]\s*([\s\S]*?)(?=\n\s*(?:由上述图表可知|1\s*[）)]|$))/i
    );

    if (summaryMatch) {
      summary = summaryMatch[1]
        .replace(/\s+/g, " ")
        .trim();
    }

    /*
     * ------------------------------------------------------------
     * Extract numbered conclusions
     * ------------------------------------------------------------
     *
     * Supports:
     *
     * 1）xxxx
     * 2）xxxx
     *
     * and
     *
     * 1) xxxx
     * 2) xxxx
     */

    const conclusionRegex =
      /(?:^|\n)\s*(\d+)\s*[）)]\s*([\s\S]*?)(?=\n\s*\d+\s*[）)]|$)/g;

    let match;

    while ((match = conclusionRegex.exec(normalizedText)) !== null) {
      const number = match[1];

      const conclusionText = match[2]
        .replace(/\s+/g, " ")
        .trim();

      if (conclusionText) {
        conclusions.push({
          number,
          text: conclusionText,
        });
      }
    }

    /*
     * ------------------------------------------------------------
     * Fallback
     * ------------------------------------------------------------
     *
     * If Summary wasn't found using the exact "Summary:" format,
     * try to locate it manually.
     */

    if (!summary) {
      const summaryIndex = normalizedText.search(
        /Summary\s*[:：]/i
      );

      if (summaryIndex !== -1) {
        const summaryStart = normalizedText
          .slice(summaryIndex)
          .replace(/^Summary\s*[:：]\s*/i, "");

        const firstConclusionIndex = summaryStart.search(
          /(?:\n|^)\s*\d+\s*[）)]/
        );

        if (firstConclusionIndex !== -1) {
          summary = summaryStart
            .slice(0, firstConclusionIndex)
            .replace(/\s+/g, " ")
            .trim();
        } else {
          summary = summaryStart
            .replace(/\s+/g, " ")
            .trim();
        }
      }
    }

    return {
      summary,
      conclusions,
    };
  };

  /*
   * Parse the dynamic Excel analysis text.
   *
   * Since analysisText comes from summaryChart, whenever the
   * uploaded Excel changes and summaryChart changes, this
   * automatically gets recalculated.
   */

  const {
    summary: dynamicSummary,
    conclusions: dynamicConclusions,
  } = parseAnalysisText(analysisText);

  /*
   * ============================================================
   * BASELINE
   * ============================================================
   */

  const getBaselineValue = (vendor) => {
    if (!vendor || !baseLine) {
      return null;
    }

    /*
     * First try exact vendor name.
     */

    if (
      Object.prototype.hasOwnProperty.call(
        baseLine,
        vendor
      )
    ) {
      const value = baseLine[vendor];

      return typeof value === "number"
        ? value
        : null;
    }

    /*
     * Fallback matching.
     *
     * This handles cases such as:
     *
     * TPV（FQ）
     * TPV (FQ)
     * TPV(FQ)
     *
     * without changing the actual displayed vendor name.
     */

    const normalizeVendorName = (name) =>
      String(name)
        .replace(/[（）]/g, "")
        .replace(/[()]/g, "")
        .replace(/\s+/g, "")
        .toUpperCase();

    const normalizedVendor =
      normalizeVendorName(vendor);

    const matchingKey = Object.keys(baseLine).find(
      (key) =>
        normalizeVendorName(key) ===
        normalizedVendor
    );

    if (!matchingKey) {
      return null;
    }

    const value = baseLine[matchingKey];

    return typeof value === "number"
      ? value
      : null;
  };

  /*
   * Create one baseline value for every category.
   *
   * Backend values are fractions:
   * 0.9 = 90%
   * 0.8 = 80%
   * 0.2 = 20%
   * 0.1 = 10%
   */

  const baselineValues = categories.map((vendor) => {
    const value = getBaselineValue(vendor);

    return value != null
      ? Math.round(value * 100)
      : null;
  });

  const chartData = {
    labels: categories,

    datasets: [
      {
        type: "bar",
        label: "SW Capability",

        data: values.map(toPercent),

        backgroundColor: categories.map((v) =>
          v?.toUpperCase().includes("TPV")
            ? "#9ca3af"
            : "#3b82f6"
        ),

        borderRadius: 0,

        maxBarThickness: 56,

        datalabels: {
          anchor: "end",
          align: "top",
          offset: 4,
          color: "white",

          font: () => {
            const width = window.innerWidth;

            let size = 15;

            if (width < 640) {
              size = 10;
            } else if (width < 1024) {
              size = 12;
            }

            return {
              size,
              weight: 600,
            };
          },

          formatter: (v) =>
            v != null
              ? `${v}%`
              : "",
        },

        order: 2,
      },

      // ==========================================
      // Dynamic baseline
      // ==========================================

      {
        type: "line",

        label: "Base Line",

        data: baselineValues,

        borderColor: "#ef4444",

        backgroundColor: "#ef4444",

        borderWidth: 3,

        pointRadius: 0,

        pointHoverRadius: 5,

        pointBackgroundColor: "#ef4444",

        pointBorderColor: "#ef4444",

        tension: 0,

        spanGaps: false,

        fill: false,

        order: 1,

        datalabels: {
          display: false,
        },
      },
    ],
  };

  /*
   * ============================================================
   * CHART
   * ============================================================
   */

  useEffect(() => {
    if (!canvasRef.current) {
      return;
    }

    const ctx = canvasRef.current.getContext("2d");

    const getAxisFontSize = () => {
      const width = window.innerWidth;

      if (width < 640) {
        return 10;
      }

      if (width < 1024) {
        return 12;
      }

      return 15;
    };

    const chart = new Chart(ctx, {
      type: "bar",

      data: chartData,

      options: {
        responsive: true,

        maintainAspectRatio: false,

        onClick: (event, elements) => {
          if (elements.length === 0) {
            return;
          }

          const element = elements[0];

          /*
           * Only respond to clicks on the BAR dataset.
           *
           * Clicking the red baseline should not
           * open the vendor detail page.
           */

          const datasetIndex =
            element.datasetIndex;

          const clickedDataset =
            chartData.datasets[datasetIndex];

          if (clickedDataset?.type !== "bar") {
            return;
          }

          const idx = element.index;

          const vendor = categories[idx];

          if (
            !vendor
              ?.toUpperCase()
              .includes("TPV")
          ) {
            onVendorClick({ vendor });
          }
        },

        plugins: {
          legend: {
            display: false,
          },

          tooltip: {
            backgroundColor: "black",
            titleColor: "white",
            bodyColor: "white",
            borderColor: "black",
            borderWidth: 1,

            callbacks: {
              title: (items) => items[0].label,

              label: (item) => {
                const val = item.raw;

                return val != null
                  ? `${item.dataset.label}: ${val}%`
                  : `${item.dataset.label}: N/A`;
              },
            },
          },

          /*
           * We don't use annotation for the
           * summary baseline anymore.
           *
           * The baseline is the line dataset above.
           */

          datalabels: {
            display: (context) =>
              context.dataset.type === "bar",
          },
        },

        scales: {
          x: {
            grid: {
              display: false,
            },

            ticks: {
              color: "white",

              font: () => ({
                size: getAxisFontSize(),
              }),
            },
          },

          y: {
            min: 0,

            max: 120,

            ticks: {
              stepSize: 20,

              callback: (v) =>
                `${v}%`,

              color: "white",

              padding: 10,

              font: () => ({
                size: getAxisFontSize(),
              }),
            },

            grid: {
              color: "white",
              borderDash: [3, 3],
            },
          },
        },
      },
    });

    chartRef.current = chart;

    return () => {
      chart?.destroy();
      chartRef.current = null;
    };
  }, [
    categories,
    values,
    baseLine,
    onVendorClick,
  ]);

  /*
   * ============================================================
   * RESPONSIVE CHART HEIGHT
   * ============================================================
   */

  const getResponsiveChartHeight = () => {
    const width = window.innerWidth;

    if (width < 640) {
      return 320;
    }

    if (width < 1024) {
      return 380;
    }

    return 450;
  };

  /*
   * ============================================================
   * UI
   * ============================================================
   */

  return (
    <div className="min-h-screen bg-black text-white">

      <div className="w-full px-4 sm:px-6 lg:px-8 pt-3 pb-10">

        {/* Header */}

        <div className="flex items-center gap-3 mb-1">

          <button
            onClick={() =>
              navigate(
                "/vendor-capability",
                {
                  state: {
                    view: "software",
                  },
                }
              )
            }
            className="p-1 hover:bg-[#1b2a3c] transition"
          >
            <ArrowLeft className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
          </button>

          <h1 className="text-base sm:text-2xl font-bold tracking-tight">
            {productType} Software Capability
          </h1>

        </div>

        {/* =====================================================
            Chart Card
        ====================================================== */}

        <div className="bg-black p-4 sm:p-6 shadow-lg border-t border-[#243448]">

          <h2 className="text-center text-sm sm:text-xl font-semibold text-white sm:mb-6 mb-2 sm:mt-5">
            ODMs SW Validation Capability
          </h2>

          <div className="flex justify-center sm:p-0 p-5 sm:-ml-0 -ml-5">

            <div
              className="w-[120%] sm:w-full max-w-[1500px]"
              style={{
                height: `${getResponsiveChartHeight()}px`,
              }}
            >
              <canvas ref={canvasRef} />
            </div>

          </div>

        </div>

        {/* =====================================================
            Analysis and Conclusions
        ====================================================== */}

        <div className="mt-1 sm:mb-1 mb-3 sm:ml-10 sm:mt-15">

          <h3 className="text-lg sm:text-2xl font-semibold">
            Analysis and Conclusions：
          </h3>

        </div>

        {/* =====================================================
            Dynamic Summary
        ====================================================== */}

        <div className="text-white text-sm sm:text-base leading-relaxed mb-1 sm:ml-10 sm:mt-8">

          {dynamicSummary && (
            <p className="mb-3 text-sm sm:text-base">

              <span className="font-semibold text-sm sm:text-base">
                Summary：
              </span>

              {" "}

              {dynamicSummary}

            </p>
          )}

          {dynamicConclusions.length > 0 && (
            <p className="mb-2">
              由上述图表可知：
            </p>
          )}

        </div>

        {/* =====================================================
            Dynamic Conclusions
        ====================================================== */}

        {dynamicConclusions.length > 0 && (

          <ol className="list-decimal pl-6 text-sm sm:text-base leading-relaxed sm:ml-10">

            {dynamicConclusions.map(
              (item, index) => (

                <li
                  key={`${item.number}-${index}`}
                  className="mb-2"
                >
                  {item.text}
                </li>

              )
            )}

          </ol>

        )}

        {/* =====================================================
            No Analysis Data
        ====================================================== */}

        {!dynamicSummary &&
          dynamicConclusions.length === 0 && (

            <div className="text-gray-400 text-sm sm:text-base sm:ml-10 mt-4">

              No analysis and conclusion data available.

            </div>

          )}

      </div>

    </div>
  );
};


const VendorDetailChart = ({
  vendorName,
  vendorChart,
  onBack,
  productType,
}) => {

  const chartRef = useRef(null);

  const canvasRef = useRef(null);

  const [screenWidth, setScreenWidth] =
    useState(window.innerWidth);

  const {
    title = `${vendorName} Function proportion`,
    functionCategories = [],
    values = [],
    baseLines = [],
    analysisText = "",
  } = vendorChart || {};

  const lineColors = [
    "#f97316",
    "#eab308",
    "#22d3ee",
    "#a78bfa",
  ];

  const getResponsiveFont = (
    desktop = 15,
    tablet = 13,
    mobile = 11
  ) => {

    const width = window.innerWidth;

    if (width < 640) {
      return mobile;
    }

    if (width < 1024) {
      return tablet;
    }

    return desktop;
  };

  const getResponsiveFontSize = (
    desktop = 10,
    tablet = 9,
    mobile = 8
  ) => {

    const width = window.innerWidth;

    if (width < 640) {
      return mobile;
    }

    if (width < 1024) {
      return tablet;
    }

    return desktop;
  };

  const chartData = {

    labels: functionCategories,

    datasets: [

      ...baseLines.map((bl, i) => ({

        type: "line",

        label: bl.label,

        data: functionCategories.map(
          (fn) =>
            toPercent(
              bl.values?.[fn] ?? null
            )
        ),

        borderColor:
          lineColors[
            i % lineColors.length
          ],

        backgroundColor:
          lineColors[
            i % lineColors.length
          ],

        borderWidth: 3,

        pointRadius: 4,

        pointHoverRadius: 6,

        tension: 0,

        spanGaps: true,

        order: 1,

      })),

      {

        type: "bar",

        label: vendorName,

        data: values.map(toPercent),

        backgroundColor: "#3b82f6",

        borderRadius: 4,

        maxBarThickness: 56,

        datalabels: {

          anchor: "end",

          align: "top",

          offset: 4,

          color: "#e2e8f0",

          font: () => ({

            size: getResponsiveFont(
              15,
              13,
              11
            ),

            weight: 600,

          }),

          formatter: (v) =>
            v != null
              ? `${v}%`
              : "",

        },

        order: 2,

      },

    ],

  };

  useEffect(() => {

    const handleResize = () => {

      setScreenWidth(
        window.innerWidth
      );

    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );

  }, []);

  useEffect(() => {

    if (!canvasRef.current) {
      return;
    }

    const allValues = [

      ...values.map(toPercent),

      ...baseLines.flatMap(
        (bl) =>
          functionCategories.map(
            (fn) =>
              toPercent(
                bl.values?.[fn] ?? 0
              )
          )
      ),

    ];

    const validValues =
      allValues.filter(
        (v) =>
          v != null &&
          !isNaN(v)
      );

    const maxValue =
      validValues.length
        ? Math.max(...validValues)
        : 0;

    const getStepSize = (max) => {

      if (max <= 90) {
        return 10;
      }

      if (max <= 180) {
        return 20;
      }

      if (max <= 250) {
        return 50;
      }

      if (max <= 500) {
        return 100;
      }

      return 200;
    };

    const stepSize =
      getStepSize(maxValue);

    const roundedMax =
      Math.ceil(
        maxValue / stepSize
      ) * stepSize;

    const yAxisMax =
      roundedMax + stepSize;

    const ctx =
      canvasRef.current.getContext(
        "2d"
      );

    const chart = new Chart(ctx, {

      data: chartData,

      options: {

        responsive: true,

        maintainAspectRatio: false,

        plugins: {

          legend: {

            position: "bottom",

            labels: {

              color: "#94a3b8",

              font: () => ({
                size: getResponsiveFont(
                  15,
                  13,
                  11
                ),
              }),

              padding: 16,

              boxWidth: 100,

              sort: (a, b) => {

                const getPriority =
                  (label) => {

                    if (
                      label ===
                      vendorName
                    ) {
                      return 0;
                    }

                    if (
                      label
                        .toLowerCase()
                        .includes("base")
                    ) {
                      return 1;
                    }

                    return 2;
                  };

                return (
                  getPriority(a.text) -
                  getPriority(b.text)
                );

              },

            },

          },

          tooltip: {

            mode: "index",

            intersect: false,

            backgroundColor: "#0f1b2b",

            titleColor: "#d1d5db",

            bodyColor: "#d1d5db",

            borderColor: "#2a3f55",

            borderWidth: 1,

            callbacks: {

              label: (item) => {

                const val =
                  item.raw;

                return `${
                  item.dataset.label
                }: ${
                  val != null
                    ? val + "%"
                    : "N/A"
                }`;

              },

            },

          },

          datalabels: {

            display: (context) =>
              context.dataset.type ===
              "bar",

          },

        },

        scales: {

          x: {

            ticks: {

              color: "#94a3b8",

              font: () => ({
                size: getResponsiveFont(
                  15,
                  13,
                  11
                ),
              }),

            },

            grid: {
              display: false,
            },

          },

          y: {

            min: 0,

            max: yAxisMax,

            ticks: {

              stepSize: stepSize,

              callback: (v) =>
                `${Number(v).toFixed(2)}%`,

              color: "#94a3b8",

              font: () => ({
                size: getResponsiveFont(
                  15,
                  13,
                  11
                ),
              }),

            },

            grid: {

              color: "white",

              borderDash: [3, 3],

            },

          },

        },

      },

    });

    chartRef.current = chart;

    return () =>
      chart?.destroy();

  }, [
    functionCategories,
    values,
    baseLines,
    vendorName,
    lineColors,
    screenWidth,
  ]);

  const getResponsiveChartHeight =
    () => {

      const width =
        window.innerWidth;

      if (width < 640) {
        return 390;
      }

      if (width < 1024) {
        return 380;
      }

      return 450;
    };

  return (

    <div className="min-h-screen bg-black text-white">

      <div className="w-full px-4 sm:px-6 pt-6 pb-10">

        <div className="flex items-center gap-3 mb-1">

          <button
            onClick={onBack}
            className="p-1 hover:bg-[#1b2a3c] transition"
          >

            <ArrowLeft className="w-5 h-5 sm:w-7 sm:h-7 text-white" />

          </button>

          <h1 className="text-base sm:text-2xl font-bold tracking-tight">

            {productType} Software Capability

          </h1>

        </div>

        <div className="bg-black p-4 sm:p-6 mb-5 sm:mt-0 -mt-6 text-center shadow-lg border-t border-[#243448]">

          <h2 className="text-center text-sm sm:text-xl font-semibold text-white mb-5">

            {title}

          </h2>

          <div className="flex justify-center">

            <div
              style={{
                height:
                  getResponsiveChartHeight(),

                width: "100%",

                maxWidth: 1500,
              }}
            >

              <canvas ref={canvasRef} />

            </div>

          </div>

        </div>

        <div className="w-full flex justify-center -mt-5 sm:mb-5">

          <div className="bg-black p-4 sm:p-1 border border-black w-full max-w-[1500px]">

            <p className="text-xs sm:text-lg font-bold mb-1 text-white">

              Remark：

            </p>

            <p className="text-xs sm:text-lg text-white leading-relaxed">

              The percentage of each function on the chart is the number of test
              cases for the corresponding function module of the ODM / the number
              of test cases for the corresponding function module of the TPV.

            </p>

          </div>

        </div>

        {analysisText && (

          <div className="bg-black rounded-2xl sm:p-10 border border-black">

            <h3 className="text-sm sm:text-2xl font-semibold mb-2">

              Analysis and Conclusions：

            </h3>

            <p className="text-xs sm:text-sm text-white leading-relaxed whitespace-pre-line">

              {analysisText}

            </p>

          </div>

        )}

      </div>

    </div>

  );
};


export default function TVSoftwareCapability() {

  const navigate = useNavigate();
  const location = useLocation();

  const productType =
  location.state?.productType ||
  (
    location.pathname === "/tv-software-capability"
      ? "TV"
      : location.pathname === "/mnt-software-capability"
      ? "Monitor"
      : location.pathname === "/pd_signage_iwb-software-capability"
      ? "PD_Signage & IWB"
      : location.pathname === "/pd_rgb_led-software-capability"
      ? "PD_RGB LED"
      : location.pathname === "/pd_aio-software-capability"
      ? "PD_AIO"
      : location.pathname === "/pd_epd-software-capability"
      ? "PD_EPD"
      : location.pathname === "/ava_audio-software-capability"
      ? "AVA_Audio"
      : location.pathname === "/ava_headphone-software-capability"
      ? "AVA_Headphone"
      : "TV"
  );

const parentProductType =
  location.state?.parentProductType ||
  (
    productType.startsWith("PD_")
      ? "PD"
      : productType.startsWith("AVA_")
      ? "AVA"
      : productType
  );

  /*
   * Keep parentProductType available for future use.
   * It is intentionally not used for the API request because
   * PD and AVA need their selected subtype.
   */

  const [view, setView] =
    useState("summary");

  const [selectedVendor, setSelectedVendor] =
    useState(null);

  const [apiData, setApiData] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState(null);

  /*
   * ============================================================
   * API PRODUCT TYPE
   * ============================================================
   *
   * UI name:
   * Monitor
   *
   * Backend/API name:
   * MNT
   *
   * Everything else is passed as-is.
   */

  const apiProductType =
    productType === "Monitor"
      ? "MNT"
      : productType;

  /*
   * ============================================================
   * FETCH DATA
   * ============================================================
   */

  const fetchData = async () => {

    try {

      setLoading(true);

      setError(null);

      console.log(
        "SW Capability - Selected Product Type:",
        productType
      );

      console.log(
        "SW Capability - Parent Product Type:",
        parentProductType
      );

      console.log(
        "SW Capability - API Product Type:",
        apiProductType
      );

      const result =
        await getSWCapabilityData({

          category:
            "Vendor Capability",

          sub_category:
            "software",

          /*
           * IMPORTANT:
           *
           * Previously all product types were sent here:
           *
           * [
           *   "TV",
           *   "MNT",
           *   "PD_Signage & IWB",
           *   ...
           * ]
           *
           * Now only the currently selected
           * product type is sent.
           */

          productType: [
            apiProductType,
          ],

        });

      console.log(
        "SW Capability API Result:",
        result
      );

      /*
       * ========================================================
       * NO ACTIVE TEMPLATE
       * ========================================================
       */

      if (
        result?.success === false &&
        result?.error ===
          "Template not found"
      ) {

        await Swal.fire({

          icon: "warning",

          title:
            "Template Missing",

          text:
            "File needs to be uploaded in Template Management",

          confirmButtonText:
            "OK",

          confirmButtonColor:
            "#2563eb",

          background:
            "white",

          color:
            "black",

        });

        /*
         * Go back to Vendor Capability
         * after OK.
         */

        navigate(
          "/vendor-capability",
          {
            state: {
              view: "software",
            },
          }
        );

        return;
      }

      /*
       * ========================================================
       * SET API DATA
       * ========================================================
       */

      setApiData(
        result?.data ?? result
      );

    } catch (err) {

      console.error(
        "API Error:",
        err
      );

      setError(
        err?.message ??
          "Failed to load data"
      );

    } finally {

      setLoading(false);

    }

  };

  /*
   * ============================================================
   * RE-FETCH WHEN PRODUCT TYPE CHANGES
   * ============================================================
   *
   * This is important because the same component is now being
   * used for TV, Monitor, PD subtypes and AVA subtypes.
   */

  useEffect(() => {

    fetchData();

  }, [productType]);

  /*
   * ============================================================
   * LOADING
   * ============================================================
   */

  if (loading) {
    return <LoadingState />;
  }

  /*
   * ============================================================
   * ERROR
   * ============================================================
   */

  if (error) {

    return (
      <ErrorState
        message={error}
        onRetry={fetchData}
      />
    );

  }

  /*
   * ============================================================
   * NO API DATA
   * ============================================================
   */

  if (!apiData) {

    return (
      <ErrorState
        message="No data returned from server."
        onRetry={fetchData}
      />
    );

  }

  /*
   * ============================================================
   * VENDOR DETAIL
   * ============================================================
   */

  if (
    view === "vendor-detail" &&
    selectedVendor
  ) {

    return (

      <VendorDetailChart

        vendorName={
          selectedVendor
        }

        productType={
          productType
        }

        vendorChart={
          apiData
            .vendorCharts?.[
              selectedVendor
            ] ?? {}
        }

        onBack={() => {

          setSelectedVendor(null);

          setView("summary");

        }}

      />

    );

  }

  /*
   * ============================================================
   * SUMMARY
   * ============================================================
   */

  return (

    <SummaryChart

      summaryChart={
        apiData.summaryChart ?? {}
      }

      /*
       * IMPORTANT:
       *
       * Pass the selected product type
       * to SummaryChart.
       */

      productType={
        productType
      }

      onVendorClick={(entry) => {

        setSelectedVendor(
          entry.vendor
        );

        setView(
          "vendor-detail"
        );

      }}

      onBack={() =>
        navigate(-1)
      }

    />

  );

}